
@if (errorCode==1) {
  <div>
    <div class="payment-info_card-authentication payment-info_failureMsg">
      <div class="payment-info_failure-header">{{"errormessage.title1" | cxTranslate}}</div>
      <div class="payment-info_failure-body" [innerHTML]="'errormessage.message1' | cxTranslate"></div>
      <div class="payment-info_failure-button">
        <button class="payment-info_retry" (click)="ChangeClicked()">{{"errormessage.retryorchangelabel" | cxTranslate}}</button>
        <button class="payment-info_cancel" (click)="ChangeClicked()">{{"errormessage.cancellabel" | cxTranslate}}</button>
      </div>
    </div>
  </div>
}
@if (errorCode==2) {
  <div>
    <div class="payment-info_unable-to-proceed payment-info_failureMsg">
      <div class="payment-info_failure-header">{{"errormessage.title2" | cxTranslate}}</div>
      <div class="payment-info_failure-body" [innerHTML]="'errormessage.message2' | cxTranslate"></div>
      <div class="payment-info_failure-button">
        <button class="payment-info_retry" (click)="ChangeClicked()">{{"errormessage.changelabel" | cxTranslate}}</button>
        <button class="payment-info_cancel" (click)="ChangeClicked()">{{"errormessage.cancellabel" | cxTranslate}}</button>
      </div>
    </div>
  </div>
}
@if (errorCode==3) {
  <div>
    <div class="payment-info_not-saved payment-info_failureMsg">
      <div class="payment-info_failure-header">{{"errormessage.title3" | cxTranslate}}</div>
      <div class="payment-info_failure-body" [innerHTML]="'errormessage.message3' | cxTranslate"></div>
      <div class="payment-info_failure-button">
        <button class="payment-info_retry" (click)="ChangeClicked()">{{"errormessage.retryorchangelabel" | cxTranslate}}</button>
        <button class="payment-info_cancel" (click)="ChangeClicked()">{{"errormessage.cancellabel" | cxTranslate}}</button>
      </div>
    </div>
  </div>
}